const paths = {
  HomeInit: '/home',
  Login: '/login',
  Register: '/cadastro',
  Products: '/produtos',
  Payment: '/pagamento',
  StatusOrders: '/status-pedidos',
  Public: '/',
  ListProducts: '/listar-produtos',
  ListCategory: '/listar-categorias',
  NewCategory: '/nova-categoria',
  EditCategory: '/editar-categoria',
  NewProducts: '/novo-produto',
  EditProducts: '/editar-produtos',
  Order: '/pedidos',
  Cart: '/carrinho',
  User: '/usuario'
}

export default paths
